import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IInvitation, ILoginInfo } from "../interface/IAccount";
import { InvitationParamModel, InvitationSendParamModel } from "../model/account";
import { LoginParamModel } from "../model/login";
import InvitationService from "../service/InvitationService";

import { RootState } from "../store/store";
import { logoutUser } from "./common";

type SliceState = { value: IInvitation ,status:string } 
const initialState = {
  value: {},
  status: COMMON_STATUS.INITIAL
} as SliceState;

const _service = new InvitationService();

export const invitationAsync = createAsyncThunk(
  "invitation/invite",
  async (params:InvitationParamModel) => {
    const response = await _service.invitationService(params);
    return response;
  }
);



export const invitationSlice = createSlice({
  name: "invitation",
  initialState,
  reducers:{
  },
  extraReducers: (builder) => {
    builder
      .addCase(invitationAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(invitationAsync.fulfilled, (state:SliceState, action:any) => {
          state.value = action.payload;
          state.status = COMMON_STATUS.LOADED;
      })
      .addCase(invitationAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
      })
     
      .addCase(logoutUser, () => {
        return initialState;
      });
  },
});

export const getInvitiation= (state:RootState) => state.invitation;

export default invitationSlice.reducer;